import Vue from 'vue';

const defaultState = () => {
  return {
    userProfileConfigs: {},
  };
};

const state = defaultState();

const getters = {
  all: state => Object.keys(state.userProfileConfigs).reduce((acc, curr) => acc.concat(state.userProfileConfigs[curr]), []),
  get: state => state.userProfileConfigs,
};

const mutations = {
  set(state, configs = []) {
    const allConfigs = configs.map(config => {
      const camelCaseColumnName = config.userProfileColumnName.replace(/([_][a-z])/g, (group) => group.toUpperCase().replace('_', ''));
      config.userProfileColumnName = camelCaseColumnName;
      return config;
    });

    // Set all configs to a keyed object by the classification they belong to
    const configsByClassification = allConfigs.reduce((acc, curr) => {
      acc[curr.classificationId] = [...(acc[curr.classificationId] || []), curr];
      return acc;
    }, {});

    Object.keys(configsByClassification).forEach(classificationId => {
      Vue.set(state.userProfileConfigs, classificationId, configsByClassification[classificationId]);
    });
  },
};

export default {
  namespaced: 'true',
  state,
  getters,
  mutations,
};
